import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortBy'
})
export class SortByPipe implements PipeTransform {
  transform(array: any, field: string): any[] {
    if (!Array.isArray(array)) {
      return [];
    }
    if(field){
    array.sort((a: any, b: any) => {
      a[field] = !a[field] ? '' : a[field];
      b[field] = !b[field] ? '' : b[field];
      if (a[field].toString().toLowerCase() < b[field].toString().toLowerCase()) {
        return -1;
      } else if (a[field].toString().toLowerCase() > b[field].toString().toLowerCase()) {
        return 1;
      } else {
        return 0;
      }
    });
  }else{
    array.sort((a: any, b: any) => {
      if (a < b) {
        return -1;
      } else if (a > b) {
        return 1;
      } else {
        return 0;
      }
    });
  }
     return array;
  }
}